import { simpleSet } from '@r/reducers/utils';

const setCalculationModeCountertopOptions = simpleSet as
  redux.reducers.calculationMode.settings.materials.countertop.options;

export const options = setCalculationModeCountertopOptions(
  'SET_CALCULATION_MODE_COUNTERTOP_OPTIONS',
  []
);
